<button
  [disabled]="disabled"
  class="dropdown-item btn-sm"
  [ngClass]="{ 'mb-2' : marginBottom }"
  type="button"
  (click)="actionPerformed.emit()"
><ng-content></ng-content></button>
